import { PropsWithChildren } from 'react';

import { datadogRum } from '@datadog/browser-rum';
import { storageHelper, User } from '@spo/logic';
import { environment } from '../../environments/environment';
import { DatadogRumProps } from './datadog-rum.props';

let initialized = false;

export interface DataDogUser {
  user_uid: string | undefined;
  user_country: string | undefined;
  user_email: string | undefined;
  user_firstname: string | undefined;
  user_job: string | undefined;
  user_lastname: string | undefined;
  user_role: string[];
}

const getUserInfo = (currentUser: User): DataDogUser => ({
  user_uid: currentUser?.uid,
  user_country: currentUser?.c,
  user_email: currentUser?.mail,
  user_firstname: currentUser?.username,
  user_job: currentUser?.jobname,
  user_lastname: currentUser?.familyName,
  user_role: [],
});

export const allowedTracingUrl = (url: string) => url.includes('/api/');

export const DatadogRum = ({
  applicationId,
  clientToken,
  sessionReplaySampleRate,
  children,
}: PropsWithChildren<DatadogRumProps>) => {
  const currentUser = storageHelper.getItem<User>('user')!;
  const user = getUserInfo(currentUser);

  if (
    !initialized &&
    applicationId &&
    clientToken &&
    user &&
    environment.datadogEnv !== 'local'
  ) {
    datadogRum.init({
      applicationId: environment.datadogApplicationId,
      clientToken: environment.datadogClientToken,
      site: 'datadoghq.eu',
      service: environment.datadogServiceName,
      env: environment.datadogEnv,
      allowedTracingUrls: [allowedTracingUrl],
      version: environment.datadogVersion,
      sessionSampleRate: 100,
      sessionReplaySampleRate,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
    });
    datadogRum.setUser({
      email: user.user_email || 'unknown',
      id: user.user_uid,
      name: `${user.user_firstname || ''} ${user.user_lastname || ''}`,
    });
    datadogRum.setUserProperty('country', user.user_country);
    datadogRum.setUserProperty('job', user.user_job);
    datadogRum.setUserProperty('role', user.user_role);
    datadogRum.startSessionReplayRecording();
    // eslint-disable-next-line react-hooks/globals
    initialized = true;
  }
  return <>{children}</>;
};
